import React from "react";
import { withRouter } from "us.common/wIthRouter";
import { BMD } from "us.collection/components";

interface ICnt_BMD {}

const Cnt_BMD: React.FC<ICnt_BMD> = (props) => {

  return (<BMD />);
};

export default withRouter(Cnt_BMD);
